import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as projects from '../../../../projects'
import * as entry from '../entry'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: entry.RESOURCE.payload.dimension.partialId,
      partialId: entry.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Associated project',
    isOptional: true,
    name: 'Project',
    partialId: PartialId.Standard.create('proj'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(projects.RESOURCE.payload),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
